import { forwardRef, HTMLAttributes } from 'react';
import { clsx } from 'clsx';
import { Icon } from './Icon';

export interface RoundIconProps {
  dataId: string;
  iconName: string;
  containerBg?: string;
  containerSize?: number;
  isIconColorWhite?: boolean;
  hasBg?: boolean;
  isRounded?: boolean;
  hasBorder?: boolean;
  showSpinningAnimation?: boolean;
  iconClasses?: string;
  className?: string;
}

export const RoundIcon = forwardRef<
  HTMLSpanElement,
  RoundIconProps & HTMLAttributes<HTMLSpanElement>
>(
  (
    {
      dataId = '',
      iconName,
      containerBg,
      containerSize = 1,
      isIconColorWhite = true,
      hasBg = true,
      isRounded = true,
      hasBorder = false,
      showSpinningAnimation = false,
      iconClasses = '',
      className
    },
    ref
  ) => {
    const classNames = clsx(
      `hd-rounded-icon-container container-size-${containerSize}`,
      {
        [`bg-${containerBg}`]: hasBg && containerBg,
        'with-white-icon': isIconColorWhite,
        'with-container-rounded': isRounded,
        'with-container-border': hasBorder,
        'with-icon-spinning': showSpinningAnimation
      },
      className
    );

    return (
      <span data-id={dataId} className={classNames} ref={ref}>
        <Icon name={iconName} className={iconClasses} dataId={dataId} />
      </span>
    );
  }
);
